'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'car-mirrors';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e343';
var svgPathData = 'M197.4 96c-13.6 0-25.7 8.6-30.2 21.4l-26.1 74.6 293.8 0-26.1-74.6C404.3 104.6 392.2 96 378.6 96L197.4 96zM32 256c-17.7 0-32-14.3-32-32s14.3-32 32-32l41.3 0 33.5-95.7C120.3 57.8 156.6 32 197.4 32l181.2 0c40.8 0 77.1 25.8 90.6 64.3l33.5 95.7 41.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 192c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-320 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-192zm96 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCarMirrors = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;